// Takes a pathanme string and checks it for a '/'
// If not it adds a '/' to tell Gatsby link that it is a relative path
export default (pathname: string) => {
  const normalizedPathname = pathname?.startsWith('/')
    ? pathname
    : `/${pathname}`;

  return normalizedPathname;
};
